import { render, staticRenderFns } from "./FencingInfoCard.vue?vue&type=template&id=550fb126"
import script from "./FencingInfoCard.vue?vue&type=script&lang=js"
export * from "./FencingInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports